export default __webpack_public_path__ + "fonts/cinzel-regular.woff!static";